var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.672 16.733a7.5 7.5 0 111.161-.96l4.197 4.197a.75.75 0 11-1.06 1.06l-4.297-4.297zM16.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z",
    fill: "currentColor"
  })));
}
SvgSearchFilled.displayName = 'SearchFilled';
export default SvgSearchFilled;